// extracted by mini-css-extract-plugin
module.exports = {"codeSnippet":"styles_codeSnippet__1hyNp","description":"styles_description__2Clyf"};